export function getDownloadFileName(header: string | null): string {
  const invalid = (): never => { throw new Error('The download file name is missing or invalid.'); };
  if (!header || /[\u0000-\u001f\u007f]/.test(header)) return invalid();

  const parts: string[] = [];
  let part = '';
  let quoted = false;
  let escaped = false;
  for (const character of header) {
    if (character === ';' && !quoted) {
      parts.push(part.trim());
      part = '';
      continue;
    }
    part += character;
    if (escaped) escaped = false;
    else if (character === '\\' && quoted) escaped = true;
    else if (character === '"') quoted = !quoted;
  }
  if (quoted || escaped) return invalid();
  parts.push(part.trim());
  if (!/^(attachment|inline)$/i.test(parts.shift() ?? '')) return invalid();

  const parameters = new Map<string, string>();
  for (const parameter of parts) {
    const match = /^([!#$%&'*+.^_`|~\w-]+)\s*=\s*("(?:[^"\\]|\\.)*"|[!#$%&'*+.^_`|~\w-]+)$/.exec(parameter);
    if (!match) return invalid();
    const key = match[1].toLowerCase();
    if (parameters.has(key)) return invalid();
    parameters.set(key, match[2]);
  }

  let fileName: string;
  const extended = parameters.get('filename*');
  if (extended !== undefined) {
    const match = /^utf-8'[^']*'(.+)$/i.exec(extended);
    if (!match) return invalid();
    try {
      fileName = decodeURIComponent(match[1]);
    } catch {
      return invalid();
    }
  } else {
    const plain = parameters.get('filename');
    if (plain === undefined) return invalid();
    fileName = plain.startsWith('"') ? plain.slice(1, -1).replace(/\\(.)/g, '$1') : plain;
  }

  if (!fileName || fileName.trim() !== fileName || fileName === '.' || fileName === '..' ||
    /[/\\:*?"<>|\p{C}]/u.test(fileName)) return invalid();
  return fileName;
}
